import React from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';

import { Card, GridForm, Input, Button, AuthComponent, NetworkLoader } from '../components';
import { formValidators, FormDelegate, AuthDelegate } from '../utils';
import { routes, fetchTypes, requestStatus } from '../constants';
import { ResourceActions } from '../actions';

class PasswordResetPage extends AuthComponent {
    constructor(props) {
        super(props);

        this.formDelegate = new FormDelegate();
        this.formDelegate.onChange((output, valid, inputs) => this.changeHandler(output, valid, inputs));
        this.formDelegate.onSubmit((output, valid, inputs) => this.submitHandler(output, valid, inputs));

        this.state = {
            errorMessage: '',
            formData: {}
        }
    }

    userIsAuthorized(user) {
        if (!this.props.location.query.code || !this.props.location.query.email) {
            return false;
        }

        return AuthDelegate.userIsLoggedIn(false)(user);
    }

    componentWillRejectUser() {
        if (!this.props.location.query.code || !this.props.location.query.email) {
            browserHistory.push(routes.LOGIN);
            return;
        }

        browserHistory.push(routes.HOME);
    }

    changeHandler(output) {
        this.setState({
            errorMessage: this.errorMessage(),
            formData: output
        });
    }

    submitHandler(output, valid) {
        this.setState({
            errorMessage: this.errorMessage()
        });

        if (valid) {
            let submission = Object.assign({}, output, {
                code: this.props.location.query.code,
                email: this.props.location.query.email
            });
            this.props.dispatch(ResourceActions.resourceFetch(fetchTypes.RESET_PASSWORD, submission));
        }
    }

    errorMessage() {
        let errors = this.formDelegate.getErrors();
        return errors[0] ? errors[0].message : '';
    }

    renderForm() {
        const errMsg = this.props.resetResult.error ? this.props.resetResult.error.message : this.state.errorMessage;

        return (
            <NetworkLoader status={this.props.resetResult.status}>
                <form onSubmit={e => this.formDelegate.submit(e)}>
                    <GridForm>
                        <div className="form-group">
                            <label className="form-control">New Password</label>
                            <Input className="form-control" name="password" delegate={this.formDelegate} validators={formValidators.required({ message: 'Please enter a valid password.' })} type="password" />
                        </div>
                        <div className="form-group">
                            <label className="form-control">Confirm Password</label>
                            <Input className="form-control" name="confirmPassword" delegate={this.formDelegate} validators={formValidators.equals({ message: 'Passwords don\'t match.' }, this.state.formData.password)} type="password" />
                        </div>
                    </GridForm>
                    <div className="form-footer">
                        <div className="form-error">{errMsg}</div>
                        <Button className="primary" type="submit">Submit</Button>
                    </div>
                </form>
            </NetworkLoader>
        )
    }

    renderSuccess() {
        return (
            <div className="reset-success">
                <h4>Password successfully reset. Please log in with your new password.</h4>
                <Button className="primary" to={routes.LOGIN}>Go Log In</Button>
            </div>
        )
    }

    authRender () {
        let actionBlock;
        if (this.props.resetResult.status === requestStatus.COMPLETE) {
            actionBlock = this.renderSuccess();
        } else {
            actionBlock = this.renderForm();
        }

        return (
            <div className="container component-login-widget" id="container-password-reset">
                <div className="row center-cols">
                    <div className="col-md-6 col-lg-5 center">
                        <Card>
                            <div className="card-title-area">
                                <h3>Reset Your Password</h3>
                            </div>
                            <div className="card-body">
                                { actionBlock }
                            </div>
                        </Card>
                    </div>
                </div>
            </div>
        )
    }
}

function select(state) {
    return {
        user: state.activeUser,
        resetResult: state.passwordResetStatus
    }
}

export default connect(select)(PasswordResetPage);



// WEBPACK FOOTER //
// ./web-app/containers/password-reset.jsx